import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'

// ─── Queries ──────────────────────────────────────────────────────────────

export function useNodes() {
  return useQuery({
    queryKey: ['nodes'],
    queryFn: api.listNodes,
    refetchInterval: 10_000,
  })
}

export function useContainers(nodeId: number | undefined) {
  return useQuery({
    queryKey: ['containers', nodeId],
    queryFn: () => api.listContainers(nodeId!),
    enabled: nodeId !== undefined,
    refetchInterval: 10_000,
  })
}

export function useContainerLogs(
  id: string | undefined,
  nodeId: number | undefined,
  tail = 100,
) {
  return useQuery({
    queryKey: ['container-logs', nodeId, id, tail],
    queryFn: () => api.containerLogs(id!, nodeId!, tail),
    enabled: id !== undefined && nodeId !== undefined,
    refetchOnWindowFocus: false,
  })
}

// ─── Mutations ────────────────────────────────────────────────────────────

export function useRestartContainer() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, nodeId }: { id: string; nodeId: number }) =>
      api.restartContainer(id, nodeId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['containers'] })
    },
  })
}

export function useStopContainer() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, nodeId }: { id: string; nodeId: number }) =>
      api.stopContainer(id, nodeId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['containers'] })
    },
  })
}

export function useStartContainer() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, nodeId }: { id: string; nodeId: number }) =>
      api.startContainer(id, nodeId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['containers'] })
    },
  })
}
